import axios from "axios";
const API_HOST = process.env.REACT_APP_API_HOST;
console.log(API_HOST);

class TransactionService {
  getIntroducerSingleUser(id, user) {
    return axios({
      method: "get",
      url: `${API_HOST}/api/introducer-account-summary/${id}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  getIntroducerUserData(id, user) {
    console.log(id)
    return axios({
      method: "get",
      url: `${API_HOST}/api/introducer-user/accountsummary/${id}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }


  introducerAllTransactionReport(user, data, page, limit) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/introducer-account-summary?page=${page}&pageSize=${limit}`,
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  allUserStatementReport(user, payload, page, pageLimit) {
    return axios({
      method: "get",
      url: `${API_HOST}/api/introducer/transaction/get`,
      params: {
        page,
        pageSize: pageLimit,
        transactionType: payload.transactionType,
        bankName: payload.bankName,
        websiteName: payload.websiteName,
        subAdminId: payload.subAdminId,
        startDate: payload.startDate,
        endDate: payload.endDate,
      },
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

}
export default new TransactionService();
